<template>
  <div class="flex">
    <ProfileField
      id="first-name"
      v-model="firstName"
      class="flex-1 pr-4"
      label="First Name"
      :error="errors.get('first_name')"
    />
    <ProfileField
      id="last-name"
      v-model="lastName"
      class="flex-1"
      label="Last Name"
      :error="errors.get('last_name')"
    />
  </div>
</template>

<script type="text/babel">
import ProfileField from './ProfileField'

export default {
  name: 'ProfileName',
  components: {
    ProfileField,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
  },
  computed: {
    firstName: {
      get() {
        return this.value.first_name
      },
      set(value) {
        this.emit({ first_name: value })
      },
    },
    lastName: {
      get() {
        return this.value.last_name
      },
      set(value) {
        this.emit({ last_name: value })
      },
    },
  },
  methods: {
    emit(data) {
      this.$emit('input', {
        ...{
          first_name: this.value.first_name,
          last_name: this.value.last_name,
        },
        ...data,
      })
    },
  },
}
</script>
